module.exports = __webpack_public_path__ + "static/media/jonatan-pie-3l3RwQdHRHg-unsplash.ca705244.jpg";